// Footer.js

import React from 'react';
import './Footer.css';
import { FaLinkedin } from 'react-icons/fa';
import { Link } from 'react-router-dom';

const scrollToTop = () => {
  window.scrollTo({ top: 0, behavior: 'smooth' });
};

const Footer = () => {
  return (
    <footer className="footer-container">
      <div className="footer-columns">
        {/* LEFT: Bio and Contact */}
        <div className="footer-left">
          <h2 className="footer-headline">
            Attempting to Bridge<br />
            the gap between<br />
            Design and Technical Feasability
          </h2>
          <p className="footer-contact">
  {['felix', 'ljungsvik.se'].join('@')}
</p>
          <div className="footer-icons">
            <a href="https://linkedin.com/in/felix-larsson-ljungsvik-186277325" target="_blank" rel="noopener noreferrer">
              <FaLinkedin />
            </a>
          </div>
          <p className="footer-copyright">© 2025 Felix Larsson Ljungsvik</p>
        </div>

        {/* CENTER: Projects */}
        <div className="footer-projects">
          <h3 className="footer-projects-title">Projects</h3>
          <div className="footer-projects-columns">
            <ul>
            <li><Link to="/case/ai" onClick={scrollToTop}>AI-Creation</Link></li>
<li><Link to="/case/returns" onClick={scrollToTop}>clothing Returns</Link></li>
<li><Link to="/case/bar" onClick={scrollToTop}>EcoScan</Link></li>
            </ul>
          </div>
        </div>

        {/* RIGHT: Pages */}
        <div className="footer-pages">
          <h3 className="footer-pages-title">Pages</h3>
          <ul className="footer-pages-list">
            <li><Link to="/" onClick={scrollToTop}>Home</Link></li>
<li><Link to="/about-me" onClick={scrollToTop}>About Me</Link></li>
            <li>
  <a
    href="https://drive.google.com/file/d/1e540wPEIiBgox-zi0XwePUHMnEDgS0ei/view"
    target="_blank"
    rel="noopener noreferrer"
  >
    My CV
  </a>
</li>

          </ul>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
